import { useState } from "react";
import InvoiceTable from "./InvoiceTable";
import InvoiceModal from "./InvoiceModal";

const InvoiceTab = ({ project, projectData }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedInvoice, setSelectedInvoice] = useState(null);

  const openInvoice = (inv) => {
    setSelectedInvoice(inv);
    setModalOpen(true);
  };
  const closeInvoice = () => {
    setSelectedInvoice(null);
    setModalOpen(false);
  };

  // Extract budgets list (array) from project data for invoice item selection
  const budgets = projectData?.budget_data || [];
  const clientId = projectData?.project_data?.client_id;
  const projectId =
    projectData?.project_data?.pid || projectData?.project_data?.id;
  return (
    <div>
      <InvoiceTable
        onView={openInvoice}
        clientId={clientId}
        projectId={projectId}
        budgets={budgets}
      />
      <InvoiceModal
        open={modalOpen}
        onClose={closeInvoice}
        invoice={selectedInvoice}
        projectName={project?.project_name}
      />
    </div>
  );
};

export default InvoiceTab;
